import ReportEditConfigErrorTooltip from './edit_config_controller/ReportEditConfigErrorTooltip'
import {calculateTooltipOffset} from '../atBrowserUtils'

export default function ErrorTooltipsForSectionsController() {}

ErrorTooltipsForSectionsController.prototype.init = function( tooltipId, errorsToSectionElsMap, getErrorMessageFunction )
{
    this.errorTooltip = new ReportEditConfigErrorTooltip().init( tooltipId );

    this.errorsToSectionElsMap = errorsToSectionElsMap;
    this.getErrorMessageFunction = getErrorMessageFunction;

    return this;
};

ErrorTooltipsForSectionsController.prototype.updateTooltips = function( errors )
{
    for ( let possibleError in this.errorsToSectionElsMap )
    {
        if ( this.errorsToSectionElsMap.hasOwnProperty( possibleError ) )
        {
            let error = errors.includes(possibleError) ? possibleError : null;
            this.updateTooltipHandlersForSection( this.errorsToSectionElsMap[ possibleError ], error );
        }
    }
};

ErrorTooltipsForSectionsController.prototype.updateTooltipHandlersForSection = function( sectionEl, error )
{
    if ( !sectionEl )
        return;

    const self = this;
    if ( error )
    {
        sectionEl.hover( function( event ) { self.showErrorTooltip( event, error ) },
                         function() { self.hideErrorTooltip(); } );
        sectionEl.mousemove( function ( event ) { self.moveErrorTooltip( event ) } );
        sectionEl.click( function() { self.hideErrorTooltip(); }) ;
    }
    else
    {
        sectionEl.unbind( 'hover mousemove click' );
    }
};

ErrorTooltipsForSectionsController.prototype.showErrorTooltip = function( event, error )
{
    this.errorTooltip.updateUIAndShow( {errorMessage: this.getErrorMessageFunction( error ), styleClass: error + "Cls" },
                                       calculateTooltipOffset( this.errorTooltip, event ));
};

ErrorTooltipsForSectionsController.prototype.moveErrorTooltip = function( event )
{
    this.errorTooltip.move( calculateTooltipOffset( this.errorTooltip, event ) );
};

ErrorTooltipsForSectionsController.prototype.hideErrorTooltip = function()
{
    this.errorTooltip.hide();
};



// WEBPACK FOOTER //
// ./web/js/reports/ErrorTooltipsForSectionsController.js